<div #quoteChart (window:beforeunload)="ngOnDestroy()" class="quote-chart h-100 item-grid d-flex flex-column">
  <div #header class="component-header">
    <div class="d-flex">
      <span style="margin-right: 5px;">GRÁFICO</span>
    </div>
    <div class="icons gridster-ignore-drag d-flex align-items-center">
      <div class="strategies-selector" *ngIf="showTradeChart && !isMarketData">
        <div *ngIf="strategiesList?.length > 1" class="mat-title" [matMenuTriggerFor]="wks" matTooltipPosition="above"
          matTooltip="Selecionar estratégia">
          <mat-form-field *ngIf="strategiesList && strategiesList?.length > 0">
            <input readonly matInput *ngIf="loadingStrategies" value="Aguarde...">
            <input readonly matInput *ngIf="!loadingStrategies" [(value)]="orderStrategy">
            <mat-icon matSuffix *ngIf="!loadingStrategies" class="icon-arrow" svgIcon="arrow-down"></mat-icon>
          </mat-form-field>
        </div>
        <mat-menu class="custom-mat-menu worksheet mat-btn-wkst" #wks="matMenu" [overlapTrigger]="false">
          <div *ngIf="strategiesList?.length > 1">
            <mat-list *ngFor="let item of strategiesList">
              <mat-list-item id="worksheet-name-{{item.orderStrategy}}" class="list-item-menu"
                [ngClass]="{'selected' : item?.orderStrategy === orderStrategy}"
                (click)="changeStrategy(item.orderStrategy)">
                <span>{{ item?.orderStrategy }}</span>
              </mat-list-item>
            </mat-list>
          </div>
        </mat-menu>
      </div>
      <mat-slide-toggle *ngIf="!isMarketData" class="toggle-trade-section small" [(ngModel)]="showTradeChart">
      </mat-slide-toggle>
      <mat-icon *ngIf="showExpandCard" svgIcon="expand" (click)="openNewWindow()"></mat-icon>
      <mat-icon matSuffix class="gridster-ignore-drag engine" svgIcon="engine" [matTooltip]="toolTipEngine"
        [matMenuTriggerFor]="wksEngine"></mat-icon>
      <mat-menu class="custom-mat-menu worksheet settings-component mat-btn-wkst" #wksEngine="matMenu"
        [overlapTrigger]="false">
        <div class="col-12 box-title">
          <div class="row">
            <div class="col-10 p-0 title" (click)="stopPropagation()">Configurações Boleta</div>
            <div class="col-2">
              <mat-icon matSuffix svgIcon="close" [matTooltip]="'Fechar Configurações'"></mat-icon>
            </div>
          </div>
        </div>
        <div class="col-12" (click)="stopPropagation()">
          <div class="row align-items-center">
            <mat-slide-toggle class="toggle-theme small" [checked]="hiddenConfirmationBillet"
              (change)="showHiddenConfirmationBilliet()"></mat-slide-toggle>
            <span class="option-font">Ocultar PAD de confirmação</span>
          </div>
        </div>
      </mat-menu>
      <mat-icon disableWksChange svgIcon="close" (click)="removeItemFromWorkspace()" matTooltipPosition="above"
        [matTooltip]="removeFromWksTooltip">
      </mat-icon>
    </div>
  </div>
  <div class="d-flex flex-fill component-content gridster-ignore-drag">
    <trading-view class="flex-fill chart-section" parentComponent="tv-quote-chart" [symbol]="symbol"
      [interval]="interval" [timeframe]='timeframe' (currentSymbol)="onSymbolChange($event)"
      [ngClass]="{ 'position-on-back': showConfirmation }"></trading-view>
    <mat-tab-group class="trade-section" [ngClass]="{'visible': showTradeChart}" *ngIf="!isMarketData">
      <mat-tab label="PAD">
        <app-trade-chart class="trade-section" [ngClass]="{'visible': showTradeChart}" [orderStrategy]="orderStrategy"
          [data]="data" [symbol]="symbol" (showConfirmation)="toggleConfirmationBillet($event)"
          [hiddenConfirmationBillet]="hiddenConfirmationBillet">
        </app-trade-chart>
      </mat-tab>
      <mat-tab label="ORDENS">
        <app-order-chart [symbol]="symbol"></app-order-chart>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div (window:beforeunload)="closeSheet()"></div>
</div>
